import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { Document } from "@contentful/rich-text-types";
import React, { ComponentPropsWithoutRef, ElementType } from "react";
import { EmbeddedAsset, Maybe } from "../../../graphql-types";
import { createRendererOptions } from "./config";

type Props<T extends ElementType> = ComponentPropsWithoutRef<T> & {
  component?: T;
  assets?: Maybe<EmbeddedAsset[]>;
  rawContent: Document;
};

/**
 * A component that renders rich text WYSIWYG content from Contentful (with lazy-loaded images)
 */
export function RichTextRenderer<T extends ElementType>({
  assets = [],
  component: Component = "article",
  rawContent,
  ...rest
}: Props<T>) {
  const options = createRendererOptions(assets);
  return (
    <Component {...rest}>
      {documentToReactComponents(rawContent, options)}
    </Component>
  );
}
